import React from "react";
import SalesListPage from "../../../../../entities/DashboardPage/AccountingModule/Customer/SalesList";
// import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
// import AuthService from "../../../../../api/AuthService";
// import AuthService from "../../../api/AuthService";
// eslint-disable-next-line import/default
// import LoaderHelper from "../../../utils/Loader/LoaderHelper";

const SalesList = () => {

  return (
    
    <SalesListPage/>
  )


}

export default SalesList;
